module.exports = __webpack_public_path__ + "img/_DSC0544 2 3-1.6355912f.png";